import type {ListSupplierFunctionsSearchInput} from "./list-supplier-functions.schema";

import {keepPreviousData, useQuery} from "@tanstack/react-query";

import {listSupplierFunctionsQueryOptions} from "./list-supplier-functions.query-options";

export function useListSupplierFunctions(rawInput: ListSupplierFunctionsSearchInput) {
  return useQuery({
    ...listSupplierFunctionsQueryOptions(rawInput),
    placeholderData: keepPreviousData,
  });
}
